<template>
  <div style="padding-top: -2px; margin-top: -2px">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      :autofocus="autofocus"
      class="text"
      itemvalue="PrdID"
      :disabled="disabled"
      :value="value"
      id="PrdID"
      itemtext="PrdCardName"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="noDefault"
      @onClearClicked="onClearClicked()"
      @change="changeProducer($event)"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sService from "@/services/Technicalassistance/TasProducerContractService.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    produceID: {
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    PrdID: {
      type: Number,
      default: 0,
    },
    onClear: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    text() {},
    value(value) {
      this.item = value;
    },
    PrdID() {
      console.log("cambio de fag ", this.PrdID);
      // Para que Vue/sSelectGeneric detecte el cambio de 'config',
      // tenemos que reemplazar todo el objeto en lugar de solo mutar inner params.
      this.config = Object.assign({}, this.config, {
        params: {
          ...this.config.params,
          PrdID: this.PrdID || 0,
        },
      });
    },
  },
  methods: {
    changeProducer(data) {
      if (this.item > 0) {
        var prod = data.filter((x) => x.PrdID == this.item);
        this.$emit("changeProd", prod[0]);
      }
    },
    onClearClicked() {
      this.$emit("onClearClicked");
    },
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    console.log(
      "⭐ [sSelectProducerFarmLot] created()! Prop PrdID recibe:",
      this.PrdID,
    );
    this.config = {
      url: _sService.getUrllistProducerFarmLot(),
      title: this.label,
      params: {
        PrdID: this.PrdID || 0,
        search: "",
        requestID: this.$fun.getUserID(),
      },
    };
  },
};
</script>
